import { memo } from 'react';

import { Button } from 'antd';

import classnames from 'classnames';

import styles from './styles.module.scss';

const PrevNextButtons = ({ className, prevId, nextId, handlePrev, handleNext }) => {
  return (
    <div className={classnames('d-flex flex-nowrap gap-2 user-select-none', className, styles['buttons-container'])}>
      <Button className={styles['button-left']} type="primary" size="large" disabled={!prevId} onClick={handlePrev}>
        Prev
      </Button>
      <Button className={styles['button-right']} type="primary" size="large" disabled={!nextId} onClick={handleNext}>
        Next
      </Button>
    </div>
  );
};

export default memo(PrevNextButtons);
